<div class="dx-fieldset" *ngIf="model">
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'FtpServer' | translate }}</div>
        <div class="dx-field-value">
            <dx-select-box [items]="ftpServers" [(value)]="model.ftpServerId" valueExpr="id" displayExpr="name"
                [readOnly]="readOnlyUser('foresight')" (onValueChanged)="valueChanged($event)">
            </dx-select-box>
        </div>
    </div>

  <div class="dx-field">
    <div class="dx-field-label dx-field-label200">{{ 'Artikeldaten Dateiname' | translate }}</div>
    <div class="dx-field-value">
      <dx-text-box [(value)]="model.exportFileName" [readOnly]="readOnlyUser('foresight')"
                   [showClearButton]="true" (onValueChanged)="valueChanged($event)"></dx-text-box>
    </div>
  </div>
  
    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Zielordner Artikeldaten' | translate }}</div>
        <div class="dx-field-value">
            <dx-text-box [(value)]="model.articleFolder" [readOnly]="readOnlyUser('foresight')"
                [showClearButton]="true" (onValueChanged)="valueChanged($event)"></dx-text-box>
        </div>
    </div>
  

    <div class="dx-field">
        <div class="dx-field-label dx-field-label200">{{ 'Zielordner Herstellerdaten' | translate }}</div>
        <div class="dx-field-value">
            <dx-text-box [(value)]="model.manufacturerFolder" [readOnly]="readOnlyUser('foresight')"
                [showClearButton]="true" (onValueChanged)="valueChanged($event)"></dx-text-box>
        </div>
    </div>
</div>
